import set from 'lodash.set';

const getInstrumentNotationListRequestMarketFilter = (options) => {
  if (options === void 0) {
    return void 0;
  }
  const marketFilter = {
    market: {}
  };
  if (options.exclude) {
    set(marketFilter, "market.selection.exclude.ids", options.exclude);
  }
  if (options.restrict) {
    set(marketFilter, "market.selection.restrict.ids", options.restrict);
  }
  if (options.priority) {
    set(marketFilter, "market.order.ids", options.priority);
  }
  return marketFilter;
};
const getInstrumentNotationListRequestSort = (options, defaultSort) => {
  if ((options == null ? void 0 : options.priority) !== void 0) {
    return ["notations.market.id"];
  }
  return defaultSort;
};

export { getInstrumentNotationListRequestMarketFilter, getInstrumentNotationListRequestSort };
